module.exports = __webpack_public_path__ + "img/marketing_map_3.7e9f870a.png";